/* eslint-disable max-len, react/jsx-props-no-spreading, react/prop-types, react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let ProductOverviewImport;
let KeyFeaturesImport;
let ItemRelatedGroupsImport;
let FeatureBasedRecommendationsImport;
let RelatedSearchImport;
let SpecificationsImport;
let KeyProductFeaturesImport;
let MajorApplianceBuyBoxImport;
let WhatWeOfferImport;
let DeliveryAndInstallationImport;
let TextAnExpertImport;
let QuestionsAndAnswersAccordionBodyImport;
let RatingsAndReviewsAccordionBodyImport;
let SpecificationsAccordionBodyImport;
let ProductOverviewAccordionBodyImport;

/** *********************
 * IRG
 ********************** */
export const ItemRelatedGroupsLoad = () => import(
  /* webpackChunkName: "item-related-groups" */
  '@thd-olt-component-react/item-related-groups')
  .then((module) => {
    const { ItemRelatedGroups } = module;

    ItemRelatedGroupsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="item-related-groups">
          <ItemRelatedGroups {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroups = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups')).ItemRelatedGroups
  : (props) => <ItemRelatedGroupsImport {...props} />;

export const ItemRelatedGroupsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups')).ItemRelatedGroups.dataModel
  : {};

/** *********************
 * FBR
 ********************** */
export const FeatureBasedRecommendationsLoad = () => import(
  /* webpackChunkName: "feature-based-recommendations" */
  '@thd-olt-component-react/feature-based-recommendations')
  .then((module) => {
    const { FeatureBasedRecommendations } = module;
    FeatureBasedRecommendationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="feature-based-recs">
          <FeatureBasedRecommendations {...props} />
        </QueryProvider>
      );
    };
  });

export const FeatureBasedRecommendations = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations
  : (props) => <FeatureBasedRecommendationsImport {...props} />;

export const FeatureBasedRecommendationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations.dataModel
  : {};

/** *********************
* Related Search
********************** */
export const RelatedSearchLoad = () => import(
  /*  webpackChunkName: "related-search" */
  '@thd-olt-component-react/related-search')
  .then((module) => {
    const { RelatedSearch } = module;
    RelatedSearchImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="related-search">
          <RelatedSearch {...props} />
        </QueryProvider>
      );
    };
  });

export const RelatedSearch = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/related-search')).RelatedSearch
  : (props) => <RelatedSearchImport {...props} />;

export const RelatedSearchModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/related-search')).RelatedSearch.dataModel
  : {}

/** *********************
* Specifications
********************** */
export const SpecificationsLoad = () => import(
  /*  webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications')
  .then((module) => {
    const { SpecificationsDesktop } = module;
    SpecificationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="specifications">
          <SpecificationsDesktop {...props} />
        </QueryProvider>
      );
    };
  });

export const Specifications = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).Specifications
  : (props) => <SpecificationsImport {...props} />;

export const SpecificationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications')).Specifications.dataModel
  : {}

/** *********************
* Key Product Features
********************** */
export const KeyProductFeaturesLoad = () => import(
  /*  webpackChunkName: "key-product-features" */
  '@thd-olt-component-react/key-product-features')
  .then((module) => {
    const { KeyProductFeatures } = module;
    KeyProductFeaturesImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="key-product-features">
          <KeyProductFeatures {...props} />
        </QueryProvider>
      );
    };
  });

export const KeyProductFeatures = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/key-product-features')).KeyProductFeatures
  : (props) => <KeyProductFeaturesImport {...props} />;

/** *********************
* MA BuyBox
********************** */
export const MajorApplianceBuyBoxLoad = () => import(
  /*  webpackChunkName: "buybox" */
  '@thd-olt-component-react/buybox')
  .then((module) => {
    const { MajorApplianceBuyBox } = module;
    MajorApplianceBuyBoxImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="buybox">
          <MajorApplianceBuyBox {...props} />
        </QueryProvider>
      );
    };
  });

export const MajorApplianceBuyBox = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/buybox')).MajorApplianceBuyBox
  : (props) => <MajorApplianceBuyBoxImport {...props} />;

export const MajorApplianceBuyBoxModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/buybox')).MajorApplianceBuyBox.dataModel
  : {}

/** *********************
* What We Offer
********************** */
export const WhatWeOfferLoad = () => import(
  /*  webpackChunkName: "what-we-offer" */
  '@thd-olt-component-react/what-we-offer')
  .then((module) => {
    const { WhatWeOffer } = module;
    WhatWeOfferImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="what-we-offer">
          <WhatWeOffer {...props} />
        </QueryProvider>
      );
    };
  });

export const WhatWeOffer = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/what-we-offer')).WhatWeOffer
  : (props) => <WhatWeOfferImport {...props} />;

export const WhatWeOfferModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/what-we-offer')).WhatWeOffer.dataModel
  : {}

/** *********************
 * Text An Expert
 ********************** */
export const TextAnExpertLoad = () => import(
  /*  webpackChunkName: "text-an-expert" */
  '@thd-olt-component-react/text-an-expert')
  .then((module) => {
    const { TextAnExpert } = module;
    TextAnExpertImport = (props) => {
      return (
        <TextAnExpert {...props} />
      );
    };
  });

export const TextAnExpert = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/text-an-expert')).TextAnExpert
  : (props) => <TextAnExpertImport {...props} />;

export const TextAnExpertModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/text-an-expert')).TextAnExpert.dataModel
  : {}

/** *********************
* Delivery And Installation
********************** */
export const DeliveryAndInstallationLoad = () => import(
  /*  webpackChunkName: "delivery-and-installation" */
  '@thd-olt-component-react/delivery-and-installation')
  .then((module) => {
    const { DeliveryAndInstallation } = module;
    DeliveryAndInstallationImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="delivery-and-installation">
          <DeliveryAndInstallation {...props} />
        </QueryProvider>
      );
    };
  });

export const DeliveryAndInstallation = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/delivery-and-installation')).DeliveryAndInstallation
  : (props) => <DeliveryAndInstallationImport {...props} />;

export const DeliveryAndInstallationModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/delivery-and-installation')).DeliveryAndInstallation.dataModel
  : {}

/** *********************
 * Questions and Answers Accordion
 ********************** */
export const QuestionsAndAnswersAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "questions-and-answers" */
  '@thd-olt-component-react/questions-and-answers'
).then((module) => {
  const { QuestionsAndAnswersAccordionBody } = module;

  QuestionsAndAnswersAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="questions-import">
        <QuestionsAndAnswersAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const QuestionsAndAnswersAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : (props) => <QuestionsAndAnswersAccordionBodyImport {...props} />;

export const QuestionsAndAnswersAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody.dataModel
  : {};

/** *********************
 * Ratings and Reviews Accordion
 ********************** */
export const RatingsAndReviewsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews'
).then((module) => {
  const { RatingsAndReviewsAccordionBody } = module;

  RatingsAndReviewsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current}>
        <RatingsAndReviewsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const RatingsAndReviewsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : (props) => <RatingsAndReviewsAccordionBodyImport {...props} />;

export const RatingsAndReviewsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody.dataModel
  : {};

/** *********************
 * Specifications Accordion
 ********************** */
export const SpecificationsAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "specifications" */
  '@thd-olt-component-react/specifications'
).then((module) => {
  const { SpecificationsAccordionBody } = module;

  SpecificationsAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="specifications-import">
        <SpecificationsAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const SpecificationsAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody
  : (props) => <SpecificationsAccordionBodyImport {...props} />;

export const SpecificationsAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody.dataModel
  : {};

/** *********************
 * Product Overview Accordion
 ********************** */
export const ProductOverviewAccordionBodyLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview'
).then((module) => {
  const { ProductOverviewAccordionBody } = module;

  ProductOverviewAccordionBodyImport = (props) => {
    return (
      <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="product-overview-import">
        <ProductOverviewAccordionBody {...props} />
      </QueryProvider>
    );
  };
});

export const ProductOverviewAccordionBody = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : (props) => <ProductOverviewAccordionBodyImport {...props} />;

export const ProductOverviewAccordionBodyModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody.dataModel
  : {};
